import { useState } from "react";
import AddNewspaper    from "./AddNewspaper";
import AdminNewspapers from "./AdminNewspapers";
import AdminVendors    from "./AdminVendors";
import AddVendor       from "./AddVendor";
import AssignVendor    from "./AssignVendor";
import VendorAreaList  from "./VendorAreaList";
import AdminPayments   from "./AdminPayments";
import RevenueSummary  from "./RevenueSummary";
import LocationManager from "./LocationManager";
import AdminOverview   from "./AdminOverview";

const NAV = [
  { section: "Overview",
    items: [{ id: "overview", label: "Dashboard", icon: "📊" }]
  },
  { section: "Manage",
    items: [
      { id: "newspapers", label: "Newspapers",  icon: "📰" },
      { id: "vendors",    label: "Vendors",      icon: "🚴" },
      { id: "payments",   label: "Payments",     icon: "💳" },
    ]
  },
  { section: "Configuration",
    items: [
      { id: "locations",  label: "Locations",    icon: "📍" },
      { id: "assignments",label: "Assignments",  icon: "🔗" },
    ]
  },
];

const PAGE_TITLES = {
  overview:    "Dashboard Overview",
  newspapers:  "Newspapers",
  vendors:     "Vendor Management",
  payments:    "Payments & Revenue",
  locations:   "Location Management",
  assignments: "Vendor Assignments",
};

function AdminDashboard() {
  const [active, setActive] = useState("overview");
  const userName = localStorage.getItem("userName") || "Admin";

  const renderPage = () => {
    switch (active) {
      case "overview":    return <AdminOverview />;
      case "newspapers":  return (
        <div className="page">
          <AddNewspaper />
          <AdminNewspapers />
        </div>
      );
      case "vendors":     return (
        <div className="page">
          <AddVendor />
          <AdminVendors />
        </div>
      );
      case "payments":    return (
        <div className="page">
          <RevenueSummary />
          <AdminPayments />
        </div>
      );
      case "locations":   return <div className="page"><LocationManager /></div>;
      case "assignments": return (
        <div className="page">
          <AssignVendor />
          <VendorAreaList />
        </div>
      );
      default: return null;
    }
  };

  return (
    <div className="app-shell">
      {/* ── SIDEBAR ──────────────────────────────── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">📰</div>
          <div className="logo-name">PressManager</div>
          <div className="logo-tagline">Editorial Suite</div>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(group => (
            <div key={group.section}>
              <div className="nav-group-label">{group.section}</div>
              {group.items.map(item => (
                <div
                  key={item.id}
                  className={`nav-item ${active === item.id ? "active" : ""}`}
                  onClick={() => setActive(item.id)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                </div>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar">{userName[0]?.toUpperCase()}</div>
            <div className="user-info">
              <div className="user-name">{userName}</div>
              <div className="user-role">Administrator</div>
            </div>
          </div>
        </div>
      </aside>

      {/* ── MAIN ─────────────────────────────────── */}
      <main className="main-content">
        <div className="topbar">
          <div className="topbar-title">{PAGE_TITLES[active]}</div>
          <div className="topbar-right">
            <span className="role-pill admin">Admin</span>
          </div>
        </div>
        {renderPage()}
      </main>
    </div>
  );
}

export default AdminDashboard;
